import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { useVatInfo } from 'hooks/useHasVatInfo'

import { getCalculatedPriceWithoutVAT } from 'helpers/getCalculatedPriceWithoutVAT'

import { selectTaxAmount } from '../redux/selects/common'

export const usePriceWithVatAdjustment = () => {
  const hasVatInfo = useVatInfo()
  const taxAmount = useSelector(selectTaxAmount)

  const getPriceWithVatAdjustment = useCallback(
    (fullPrice: number) => {
      if (!hasVatInfo) {
        return fullPrice
      }

      return Number(getCalculatedPriceWithoutVAT(fullPrice, taxAmount))
    },
    [hasVatInfo, taxAmount],
  )

  return { getPriceWithVatAdjustment }
}
